import { forwardRef } from 'react';
import classnames from 'classnames/bind';
import * as PropTypes from 'prop-types';
import InputError from '../InputError';
import css from './Radio.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cln = classnames.bind(css);

/**
 * This component accepts all default radio input props plus additional custom props.
 * It renders a radio input wrapped in a span tag. If the "label" prop is provided then the input is wrapped in a label tag.
 */
const Radio = /*#__PURE__*/forwardRef(function Radio({
  checked,
  className,
  disabled = false,
  highlighted = false,
  containerClassName,
  error,
  label,
  onChange = () => {},
  ...rest
}, ref) {
  const Container = label ? 'label' : 'span';
  return /*#__PURE__*/_jsxs(Container, {
    className: cln('Radio', containerClassName, {
      checked,
      disabled,
      highlighted,
      error: Boolean(error),
      labelled: Boolean(label)
    }),
    children: [/*#__PURE__*/_jsx("input", {
      type: "radio",
      checked: checked,
      disabled: disabled,
      onChange: onChange,
      className: cln('input', className),
      ref: ref,
      ...rest
    }), label, error && /*#__PURE__*/_jsx(InputError, {
      children: error
    })]
  });
});
Radio.propTypes = {
  /** @ignore */
  checked: PropTypes.bool,
  /** @ignore */
  className: PropTypes.string,
  /** Custom class name set on the input container */
  containerClassName: PropTypes.string,
  /** @ignore */
  disabled: PropTypes.bool,
  /** Whether or not the component should be highlighted */
  highlighted: PropTypes.bool,
  /** Error string which should be displayed below the input field */
  error: PropTypes.string,
  /** When provided, renders a label on the right of the checkbox */
  label: PropTypes.string,
  /** @ignore */
  onChange: PropTypes.func
};
export default Radio;